// React Dependencies
import React from 'react';

// External Dependencies
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// Internal Dependencies
import Colours from '../../../styles/colours';

const SortableItem = (props) => {
  const { tag } = props;
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: tag.id });

  const style = {
    transform:       CSS.Transform.toString(transform),
    transition,
    opacity:         isDragging ? 0.5 : 1,
    zIndex:          isDragging ? 1000 : 'auto',
    cursor:          'grab',
    borderBottom:    '1px solid #e0e0e0',
    backgroundColor: Colours.White,
  };

  const badgeStyle = {
    backgroundColor: Colours.Green1,
    color:           Colours.White,
    padding:         '6px 12px',
    borderRadius:    4,
    fontSize:        14,
    fontWeight:      500,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="d-flex align-items-center py-2 px-3"
      {...attributes}
      {...listeners}
    >
      <div
        className="d-flex align-items-center justify-content-center text-muted"
        style={{ width: 40, marginLeft: 15, marginRight: 30 }}
      >
        <DragIndicatorIcon />
      </div>
      <div className="flex-grow-1">
        <span style={badgeStyle}>{tag.name}</span>
      </div>
      <div className="text-center" style={{ width: 100, fontWeight: 500 }}>
        {tag.linkedPois || 0}
      </div>
    </div>
  );
};

SortableItem.propTypes = {
  tag: PropTypes.arrayOf(PropTypes.shape(Object)).isRequired,
};

export default SortableItem;
